import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class DayStock extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.list}>
                <ul>
                    {content.map((item, index) => (
                        <li key={index}>
                            <div className={styles.pic}>
                                <a href={item.url} target="_blank" rel="noreferrer">
                                    <img src={item.thumbnail} width="300" height="166" className={styles.trans} />
                                    <div className={styles.link} />
                                </a>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(DayStock);
